import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpEvent } from '@angular/common/http';
import { finalize, tap, map } from 'rxjs/operators';
import { BaseComponents } from '../../../base.component';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { createUUID } from '../../../core/utilities';
import { TrackingIDService } from '../services/tracking-id.service';
import { encryptData, decryptData } from '../../../core/utilities';
import { ReferenceService } from 'src/app/services/reference.service';

function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    }))
  }
  

@Injectable()
export class LineHttpInterceptor extends BaseComponents implements HttpInterceptor{

    constructor(
        protected injectorObj:Injector,
        private trackingService: TrackingIDService,
        private referenceService : ReferenceService
        //private logger: NGXLogger
    ){
        super(injectorObj);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{

        // console.log("http request line li: ", request);
        // set log_session_id;
        const referenceUUID = this.referenceService.getReferenceUUID()
        if(request.url.includes('/api/line/') || request.url.includes('/api/lon/')){
            request = request.clone({
                setParams:{
                    log_session_id: this.trackingService.trackingID
                },
                setHeaders:{
                    reference_uuid: referenceUUID
                }
            })

        }
        // else{
        //     // console.log('user other service');
        //     this.logger.info('user other service');
        //     let timeout = encryptData(b64EncodeUnicode(JSON.stringify(new Date().getTime() + 3500))); //ไส่ timeout 3.5 วิ
        //     let data = encryptData(b64EncodeUnicode(JSON.stringify(request.body || {})))
        //     const mode = environment.mode;
        //     if (!(environment.mode == 'beta' && environment.sub_state == 'state2')) {
        //         request = request.clone({ body: { data: data + '[t]' + timeout } })
        //     }else{
        //         request = request.clone()
        //     }
            
        // }

        // this.logger.debug(request);
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log('event--->>>', event);
                    //this.logger.debug('http response: ', event);
                }
                return event;
            }));
    }
}